<template>
  <div class="extend_box safe-distance-top-header-two">
    <Header :pageTitle="$route.meta.title">
      <template #right>
        <p
          v-show="$route.meta.toExtend"
          class="again_btn"
          @click="$router.push('/extend/extend-market')"
        >
          推广市场
        </p>
      </template>
    </Header>
    <Router-view />
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
export default {
  name: "Extend",
  components: {
    Header,
  },
  data() {
    return {};
  },
  created() {},
};
</script>

<style scoped lang="scss">
.extend_box {
  padding-top: 44px;
  min-height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
  .again_btn {
    font-size: 15px;
    color: #333333;
    line-height: 21px;
  }
}
</style>
